import React, { useState } from "react";
import { TbSquareRoundedPercentage } from "react-icons/tb";
import { checkCouponCodeapi } from "../../redux/paymentslice";
import { useDispatch, useSelector } from "react-redux";

const CheckCoupan = () => {
    const dispatch = useDispatch();
    const [coupancode, setCoupancode] = useState("");
    const cartlistdata = useSelector((state) => state.cartslice.cartlistdata);
    const coupanmsg = useSelector((state) => state.paymentslice.coupanmsg);
    const skulist = cartlistdata?.data?.result?.map(ele => ele.sku);


    const onchange = (e) => {
        setCoupancode(e.target.value);
    };

    const checkcoupan = () => {
        const input_data = {
            coupon: coupancode,
            skulist: skulist,
            offer: 0,
            tamount: cartlistdata?.data?.grand_total.replace(/[^\d.]/g, '')
        };
        dispatch(checkCouponCodeapi(input_data));
    };

    return (
        <div>
            <div className="coupan-title">Coupons</div>
            <div className="d-flex footercontactus">
                <input
                    type="text"
                    placeholder="Enter coupon Code"
                    value={coupancode}
                    onChange={onchange}
                    className="header-inputbox coupan-input"
                />
                <div className="coupanapply secondarybackground" onClick={checkcoupan}>
                    Apply
                </div>
            </div>
            <div>{coupanmsg}</div>
            <div className="viewavailable-title cursor-pointer">
                <TbSquareRoundedPercentage className="me-1" />
                View available offers
            </div>
        </div>
    );
};

export default CheckCoupan;
